import React, { useEffect, useRef, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, IconButton } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { Input, ReactSelector, TextArea } from "../../components/Form";
import useButtonLoader from "../../hooks/UseButtonLoader";
import toast from "react-hot-toast";
import { AddCommunityApi } from "../../services/community";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import AddLocationAltTwoToneIcon from "@mui/icons-material/AddLocationAltTwoTone";
import WrongLocationTwoToneIcon from "@mui/icons-material/WrongLocationTwoTone";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import { usePlacesWidget } from "react-google-autocomplete";
import Address from "./view/Address";
import { Button } from "../../components/Button/Button";
import ReactSelect from "react-select";
import { catchMessage, elseMessage } from "../../comman/Message";
import { cityApi, countryApi, stateApi } from "../../services/masterApi";

const AddCommunity = () => {
  const nationalId = useRef();
  const navigate = useNavigate();
  const [input, setInput] = useState({
    locationType: "",
    communityName: "",
    about: "",
  }); /* communityPrivacy: "public" */
  const [image, setImage] = useState("");
  const [error, setError] = useState({});
  const [buttonref, buttonLoader] = useButtonLoader("Create community");
  const [categoryList, setCategoryList] = useState([]);

  const addressId = Date.now();
  const [selectedAddress, setSelectedAddress] = useState([
    { id: 101, address: "", latitude: "", longitude: "" },
  ]);

  const aadRow = () => {
    const newRow = { id: addressId, address: "", latitude: "", longitude: "" };
    setSelectedAddress((prevAddress) => [...prevAddress, newRow]);
  };

  const [country, setCountry] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [state, setState] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [city, setCity] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");

  //------------handle-Country-onChange--------------
  const handleCountry = (event) => {
    setSelectedCountry(event);
    setSelectedState("");
    setSelectedCity("");
    if (!event?.value) {
      setState([]);
      setSelectedState("");
      setCity([]);
      setSelectedCity("");
    }
  };
  //------------handle-state-onChange--------------
  const handleState = (event) => {
    setSelectedState(event);
    setSelectedCity("");
    if (!event?.value) {
      setCity([]);
      setSelectedCity("");
    }
  };

  //----------validation------------
  const validation = () => {
    const imageFileRegex = /\.(jpg|jpeg|png|bmp)$/i;
    let errorMessage = {};
    let status = true;

    if (input.communityName && input.about && !input.locationType) {
      // errorMessage["locationType"] = "Please choose Location";
      toast.error("Please choose Location", { id: "location" });
      status = false;
    }
    if (!input.communityName) {
      errorMessage["communityName"] = "Please enter community Name";
      status = false;
    }
    if (!input.about) {
      errorMessage["about"] = "Please enter Description";
      status = false;
    } else if (input.about.length < 200) {
      errorMessage["about"] = "Please write a minimum of 200 characters.";
      errorMessage["aboutLength"] = true;
      status = false;
    }
    if (
      input.communityName &&
      input.about &&
      input.locationType &&
      !image?.name
    ) {
      // errorMessage["image"] = "Please choose image";
      toast.error("Please choose cover image", { id: "image" });
      status = false;
    }

    if (input?.locationType === "country") {
      if (!selectedCountry?.value) {
        errorMessage["country"] = "Please select country";
        status = false;
      }
    }
    if (input?.locationType === "country") {
      if (!selectedState?.value) {
        errorMessage["state"] = "Please select state";
        status = false;
      }
    }
    if (input?.locationType === "country") {
      if (!selectedCity?.value) {
        errorMessage["city"] = "Please select city";
        status = false;
      }
    }
    setError(errorMessage);
    return status;
  };

  //------------------onChange-input-value---------------------------
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "communityName") {
      // Allow letters, numbers, spaces and special characters; just remove leading spaces and collapse multiple spaces
      const cleanedName = value
        .replace(/^[ ]+/g, "")
        .replace(/\s+/g, " ");
      setInput({ ...input, [name]: cleanedName });
    } else if (name === "locationType") {
      if (input?.locationType === "world") {
        setSelectedCountry("");
        setSelectedState("");
        setSelectedCity("");
      }
      setInput({ ...input, [name]: value });
    } else if (name === "about") {
      const cleanedName = value.replace(/^[ ]+/g, "");
      setInput({ ...input, [name]: cleanedName });
    } else if (name === "image" && files && files[0]) {
      const imageFileRegex = /\.(jpg|jpeg|png)$/i;
      if (!imageFileRegex.test(files[0].name)) {
        toast.error("Only choose image files (jpg, jpeg, png)");
        setImage("");
      } else {
        setImage(files[0]);
      }
    } else {
      setImage("");
    }
  };

  //--------------Add-community------------------------
  const addCommunity = async () => {
    const status = validation();
    if (status) {
      try {
        buttonLoader(true);
        const formData = new FormData();
        formData.append("communityName", input.communityName);
        formData.append("about", input.about);
        formData.append("image", image);
        formData.append("locationType", input.locationType);
        // formData.append("communityPrivacy", input.communityPrivacy)

        if (input?.locationType === "country") {
          formData.append(
            "country",
            JSON.stringify({
              _id: selectedCountry?.value,
              name: selectedCountry?.label,
            })
          );
          formData.append(
            "state",
            JSON.stringify({
              _id: selectedState?.value,
              name: selectedState?.label,
            })
          );
          formData.append(
            "city",
            JSON.stringify({
              _id: selectedCity?.value,
              name: selectedCity?.label,
            })
          );
        }
        const res = await AddCommunityApi(formData);
        if (res.data.status === 200) {
          toast.success(res.data.message);
          // modalClose()
          navigate("/community-circles");
          buttonLoader(false);
        } else {
          toast.error(res.data.message);
          buttonLoader(false);
        }
      } catch (e) {
        toast.error(e.message);
        buttonLoader(false);
      }
    }
  };
  //--------------country-listing------------------------
  useEffect(() => {
    const fathCountry = async () => {
      try {
        const res = await countryApi();
        if (res?.data?.status === 200) {
          // console.log("country", res?.data?.data?.country_list)
          const data = res?.data?.data?.country_list || [];
          // console.log('country', data)
          const country = data?.map(({ _id, name }) => ({
            label: name,
            value: _id,
          }));
          setCountry(country);
        } else {
          elseMessage(res);
        }
      } catch (err) {
        catchMessage(err);
      }
    };
    fathCountry();
  }, []);
  //--------------state-listing------------------------
  useEffect(() => {
    const fathState = async (countryId = selectedCountry?.value) => {
      if (selectedCountry?.value) {
        try {
          const res = await stateApi({ countryId });
          if (res?.data?.status === 200) {
            const data = res?.data?.data?.state_list || [];
            // console.log("stateApi", data)
            const state = data?.map(({ _id, name }) => ({
              label: name,
              value: _id,
            }));
            setState(state);
          } else {
            elseMessage(res);
          }
        } catch (err) {
          catchMessage(err);
        }
      }
    };
    if (selectedCountry?.value) {
      fathState(selectedCountry?.value);
    }
  }, [selectedCountry?.value]);
  //--------------city-listing------------------------
  useEffect(() => {
    const fathCity = async (
      countryId = selectedCountry?.value,
      stateId = selectedState?.value
    ) => {
      if (selectedCountry?.value && selectedState?.value) {
        try {
          const res = await cityApi({ countryId, stateId });
          if (res?.data?.status === 200) {
            const data = res?.data?.data?.city_list || [];
            // console.log("cityAPi", data)
            const city = data?.map(({ _id, name }) => ({
              label: name,
              value: _id,
            }));
            setCity(city);
          } else {
            elseMessage(res);
          }
        } catch (err) {
          catchMessage(err);
        }
      }
    };
    if (selectedCountry?.value && selectedState?.value) {
      fathCity(selectedCountry?.value, selectedState?.value);
    }
  }, [selectedCountry?.value, selectedState?.value]);
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="TitleBox">
          <h4 className="Title">
            <Link to={-1}>
              <IconButton>
                <ArrowBackIcon sx={{ color: "#C86337", fontSize: 30 }} />
              </IconButton>
            </Link>
            Create Community
          </h4>
        </div>

        <div className="row">
          <div className="col-7 mb-4">
            <div className="row">
              <div className="col-12">
                <input
                  type="file"
                  // label="Choose National Id"
                  name="image"
                  className="form-control"
                  accept="image/*"
                  onChange={handleChange}
                  ref={nationalId}
                  hidden
                  error={error?.image}
                />
                <div>
                  <label className=" text-dark">Cover Image</label>
                  {image && image?.name ? (
                    <Avatar
                      onClick={() => {
                        nationalId?.current?.click();
                      }}
                      variant="rounded"
                      id={input?._id}
                      alt={input?.name}
                      src={URL.createObjectURL(image)}
                      role="button"
                      sx={{
                        height: 250,
                        width: "auto",
                        borderRadius: 1,
                        border: "1px solid #C86337",
                      }}
                      // onClick={() => setShowImgModal(image ? true : false)}
                    >
                      <InsertPhotoIcon sx={{ fontSize: 60 }} />
                    </Avatar>
                  ) : (
                    <div>
                      <Avatar
                        className="w-100"
                        variant="rounded"
                        onClick={() => {
                          nationalId?.current?.click();
                        }}
                        sx={{
                          height: 250,
                          cursor: "pointer",
                          border: "2px dotted #C86337",
                          borderRadius: 2,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "#C86337",
                        }}
                      >
                        <PermMediaIcon sx={{ fontSize: 100 }} />
                        <div>
                          <p className="mt-2">Upload Community Cover Image</p>
                          <p
                            style={{
                              fontSize: "12px",
                              marginTop: "10px",
                              textAlign: "center",
                            }}
                          >
                            Minimum 343px Width 185px Height. Max 10MB
                          </p>
                        </div>
                      </Avatar>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-5">
            <div className="row">
              <div className="col-12 mb-3">
                <label htmlFor="">Location</label>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="locationType"
                  value={input?.locationType || ""}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="country"
                    control={<Radio />}
                    label="Country"
                  />
                  <FormControlLabel
                    value="world"
                    control={<Radio />}
                    label="World wide"
                  />
                </RadioGroup>
              </div>
              {/* <div className="col-12 mb-3">
                                <label htmlFor="">Community Privacy</label>
                                <RadioGroup row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="communityPrivacy"
                                    value={input?.communityPrivacy || ""}
                                    onChange={handleChange}
                                >
                                    <FormControlLabel value="public" control={<Radio />} label="Public" />
                                    <FormControlLabel value="private" control={<Radio />} label="Private" />
                                    <FormControlLabel value="hidden" control={<Radio />} label="Hidden" />

                                </RadioGroup>
                            </div> */}
              <div className="col-12 mb-3">
                <Input
                  type="text"
                  name="communityName"
                  value={input?.communityName || ""}
                  onChange={handleChange}
                  placeholder="Enter community Name"
                  className="form-control"
                  label="Community Name"
                  error={error.communityName}
                  maxLength={30}
                />
              </div>
              <div className="col-12 mb-3">
                <TextArea
                  type="text"
                  name="about"
                  value={input?.about || ""}
                  onChange={handleChange}
                  placeholder="Enter About And Purpose"
                  className={`form-control `}
                  label="About And Purpose"
                  error={error?.about}
                  extraErr={error?.aboutLength}
                  // maxLength={1000}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {input?.locationType === "country" && (
            <>
              <div className="col-4 mb-4">
                <ReactSelector
                  label="Country"
                  name="country"
                  placeholder={"search country"}
                  value={selectedCountry || ""}
                  className={
                    error?.country && !selectedCountry?.value
                      ? "form-control"
                      : ""
                  }
                  option={country}
                  onChange={handleCountry}
                  error={error?.country}
                />
              </div>
              <div className="col-4 mb-4">
                <ReactSelector
                  label="State"
                  name="state"
                  value={selectedState || ""}
                  className={
                    error?.state && !selectedState?.value ? "form-control" : ""
                  }
                  option={state}
                  onChange={handleState}
                  error={error?.state}
                  placeholder={"Select State"}
                />
              </div>
              <div className="col-4 mb-4">
                <ReactSelector
                  label="City"
                  name="city"
                  value={selectedCity || ""}
                  className={
                    error?.city && !selectedCity?.value ? "form-control" : ""
                  }
                  option={city}
                  onChange={(event) => setSelectedCity(event)}
                  error={error?.city}
                />
              </div>
            </>
          )}
        </div>
        <button className="btn_size" onClick={addCommunity} ref={buttonref}>
          Create Community
        </button>
      </div>
    </div>
  );
};
export default AddCommunity;
